import { QuestionCircleOutlined } from '@ant-design/icons';

import './google-auth.scss';
import * as React from 'react';
import { Modal } from '../../../../../components/modal/modal';
import { Button, buttonType } from '../../../../../components/button/button';
import OtpInput from 'react-otp-input';

type Props = {
    submitData: (e: string) => any;
    data?: SettingGoogleAuthType;
    isOpen: boolean;
    setIsOpen: React.Dispatch<boolean>;
    setData: React.Dispatch<SettingGoogleAuthType>;
    loading: boolean;
};
export interface SettingGoogleAuthType {
    code?: string;
    error?: string;
}
export const VoucherPMGoogleAuth: React.FC<Props> = ({ submitData, data, isOpen, setIsOpen, setData, loading }) => {
    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} className="setting-google-auth-modal">
            <p>کد امنیتی Google Authenticator را وارد کنید</p>
            <div className="google-auth code app-code code">
                <OtpInput
                    renderInput={(props) => <input {...props} />}
                    value={data?.code ? data?.code : ''}
                    onChange={(value: any) => {
                        setData({
                            ...data,
                            code: value,
                        });
                    }}
                    numInputs={6}
                    shouldAutoFocus
                    inputStyle={'pmx-otp-input'}
                    containerStyle={'pmx-otp-input-container'}
                />

                <div className="stats">
                    <div className="errors">
                        {data?.error && (
                            <>
                                <QuestionCircleOutlined />
                                <span>{data?.error}</span>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <Button
                type={buttonType.info}
                text="تایید"
                onClick={() => data?.code && !loading && submitData(data.code)}
                disabled={!loading && data?.code?.length != 6}
                loading={loading}
            />
        </Modal>
    );
};
